import axios from 'axios';
import { apiBaseUrl } from './config';
import { logger } from '@/utils/logger';

export async function checkTokenValid(pre, token) {
    try {
        const response = await axios.post(`${apiBaseUrl}/api/email_token/valid`, {
            action: pre,
            token: token,
        });
        if (response.status === 200) {
            logger.log('Notify settings fetched successfully:', response.data);
            if (response.data.message === "Valid") {
                return {
                    tokenValid: true,
                    auth_type: response.data.auth_type
                };
            } else if (response.data.message === "Invalid") {
                return {
                    tokenValid: false,
                    auth_type: response.data.auth_type
                };
            }
        } else {
            logger.error('Error fetching notify settings:', response);
            return {
                tokenValid: false,
                auth_type: -1
            };
        }
    } catch (error) {
        logger.error('Error during notify settings fetch:', error);
        return {
            tokenValid: false,
            auth_type: -1
        };
    }
}